import React, { useState } from "react";

import QuestionBox from "./QuestionBox";
import { Container, Title, Text, TextContainer, Anchor, UnorderedList, OrderedList, Li, Paragraph } from "./styles";

export default function FAQ() {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const checkIfCollapsed = (collapsed: boolean) => setIsCollapsed(collapsed);

  return (
    <Container isCollapsed={isCollapsed}>
      <TextContainer>
        <Text>FAQ</Text>
        <Title>Network</Title>
      </TextContainer>
      <QuestionBox
        question="Why is a VASP &amp; Crypto Companies Travel Rule Database important?"
        checkIfCollapsed={checkIfCollapsed}
        answer={
          <span>
            A VASP network helps crypto companies perform crucial due diligence on their counterparties, which is a
            crucial part of Travel Rule compliance. Under the revised{" "}
            <Anchor
              href="https://www.fatf-gafi.org/media/fatf/documents/recommendations/pdfs/FATF%20Recommendations%202012.pdf"
              target="_blank"
              rel="noreferrer"
            >
              FATF Recommendations 10-2
            </Anchor>
            , each company is required to perform due diligence on the counterpart institutions or VASPs to its
            transfers - irrespective of the jurisdiction. In order to do so, VASPs must verify that their counterparties
            are locally registered and licensed to provide virtual asset services and verify their counterparty’s
            AML/CFT practices. In addition to performing due diligence, VASPs must determine which travel rule protocols
            their counterparts use. All of this information is present in Notabene’s VASP &amp; Crypto Companies Travel
            Rule Database.
          </span>
        }
      />
      <QuestionBox
        question="Why use Notabene’s Free VASP &amp; Crypto Companies Travel Rule Database?"
        checkIfCollapsed={checkIfCollapsed}
        answer={
          <span>
            The FATF requires VASPs to know the regulatory status of each VASP they’re interacting with before
            performing travel rule transfers. Notabene’s VASP &amp; Crypto Companies Travel Rule Database creates a
            singular location where this information can be found. Dynamically updated in real-time, each page reflects
            the regulatory and business state of a VASP as well as which travel rule protocols it is live with (if
            available). Upon request, VASPs can also share info about their AML/CFT practices and data storage policies.
            Additionally, companies that do not yet have a travel rule solution in place can send compliant data
            transfers to our customers through the database.
          </span>
        }
      />
      <QuestionBox
        checkIfCollapsed={checkIfCollapsed}
        question="Which countries does the FATF Travel Rule apply to?"
        answer={
          <span>
            The FATF Travel Rule impacts two categories of businesses: financial institutions (banks, credit firms,
            etc.) and VASPs located in{" "}
            <Anchor href="https://www.fatf-gafi.org/countries/#FATF" target="_blank" rel="noreferrer">
              FATF-member countries
            </Anchor>{" "}
            and FRSB regional bodies, such as Switzerland, Germany, the US, Singapore, and more.
          </span>
        }
      />
      <QuestionBox
        checkIfCollapsed={checkIfCollapsed}
        question="What information is needed to sign up for Notabene’s VASP &amp; Crypto Companies Travel Rule Database?"
        answer={
          <span>
            When signing up as a VASP or Financial Institution, be sure to have the following documents handy:
            <UnorderedList>
              <Li>
                Business incorporation information, physical address, national business identification numbers, etc.
              </Li>
              <Li>Digital copies of incorporation documents (we’ll need this to verify your business information)</Li>
              <Li>Your company’s logo</Li>
            </UnorderedList>
          </span>
        }
      />
      <QuestionBox
        checkIfCollapsed={checkIfCollapsed}
        question="How to list my company in Notabene’s VASP &amp; Crypto Companies Travel Rule Database?"
        answer={
          <span>
            <OrderedList>
              <Li>
                <Anchor href="/auth/get-started">Sign up</Anchor> with your work email address
              </Li>
              <Li>Create your company’s profile</Li>
              <Li>Upload your company’s incorporation information and logo</Li>
              <Li>Select your Travel Rule protocols</Li>
            </OrderedList>
            You’re all set!
          </span>
        }
      />
      <QuestionBox
        checkIfCollapsed={checkIfCollapsed}
        question="How to receive compliant data transfers from counterparties using Notabene’s VASP &amp; Crypto Companies Travel Rule Database?"
        answer={
          <span>
            One benefit of using Notabene is that your counterparty VASPs can send you Travel Rule data transfers
            immediately, regardless if they have a compliance solution in place or not.
            <Paragraph>Once you’ve verified your company in the database:</Paragraph>
            <OrderedList>
              <Li>
                {" "}
                <Anchor href="https://6hsiqhirzd8.typeform.com/to/J2gBFQY9" target="_blank" rel="noreferrer">
                  Upload a list of your counterparty VASPs
                </Anchor>
              </Li>
              <Li>
                Notabene will inform your counterparties to expect Travel Rule data transfers from your company. We will
                also help them send you compliant data transfers with their incoming Travel Rule transfers.
              </Li>
              <Li>Compliant data transfers will appear in your dashboard Inbox</Li>
            </OrderedList>
          </span>
        }
      />
    </Container>
  );
}
